$(function () {
    $(".slider-news").each(function () {
        var slider = $(this).find('.slider-news-items');
        slider.slick({
            fade: false,
            dots: false,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: slider.closest('.slider-news').find('.sliderPrevButton'),
            nextArrow: slider.closest('.slider-news').find('.sliderNextButton'),
            mobileFirst: true,
            responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                }
            }, {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                }
            }]
        });
    })
});